import { observable, untracked } from 'mobx';
import { invariant, isAliasedPropSchema, isMapLike, isPropSchema } from '../utils/utils';
import { _defaultPrimitiveProp } from '../constants';
import { serialize } from '../core/serialize';
import { ChainedSchema } from './general/ChainedSchema';
import { SerializrType_primitive } from './inner/primitive';
import { DeserializeAttributeContext } from '../context/DeserializeAttributeContext';
import { universalMapKeys } from '../../mobx/utils_mobx';
import { runtime } from '../../../classes/runtime/Runtime';
export class SerializrType_map extends ChainedSchema {
    constructor(propSchema) {
        super(propSchema);
    }
    serializeKey(context, key, value) {
        if (this.parentSchema instanceof SerializrType_primitive) {
            return value;
            /*
            const target = {
              [key]: value
            };
            const objectContext = new SerializeObjectContext({ target });
            const attrContext = new SerializeAttributeContext({ objectContext, propName: key, attrName: key });
            return this.parentSchema.serializer(attrContext);
            */
        }
        return serialize(value);
    }
    serializer(context) {
        const m = context.value;
        invariant(m && typeof m === 'object', 'expected object or Map');
        const isMap = isMapLike(m);
        const result = {};
        if (isMap) {
            m.forEach((value, key) => (result[key] = this.serializeKey(context, key, value)));
            return result;
        }
        for (const key in m) {
            result[key] = this.serializeKey(context, key, m[key]);
        }
        return result;
    }
    deserializer(context) {
        const jsonObject = context.json;
        const oldMap = context.oldValue;
        if (!jsonObject || typeof jsonObject !== 'object') {
            throw '[serializr] expected JSON object;';
        }
        const jsonKeys = Object.keys(jsonObject);
        const hasOldMap = isMapLike(oldMap);
        const newMap = hasOldMap ? oldMap : runtime.runtimePermissions.hasEditFunctionality ? observable.map() : new Map();
        const oldMapKeys = untracked(() => universalMapKeys(oldMap)); // mhicke, BUG 11.06.2018 don't observe map keys!!!
        const removeKeysNotPresentInJsonObject = oldMapKeys.filter(key => !jsonKeys.includes(key));
        removeKeysNotPresentInJsonObject.forEach(removeKey => newMap.delete(removeKey));
        for (const jsonKey in jsonObject) {
            // if (jsonObject.hasOwnProperty(jsonKey)) {
            let itemPropSchema = this.parentSchema;
            if (typeof itemPropSchema === 'function') {
                itemPropSchema = itemPropSchema(jsonObject[jsonKey], context.objectContext);
            }
            const newOldValue = hasOldMap && oldMap.get(jsonKey);
            const newContext = new DeserializeAttributeContext({
                ...context,
                json_overwrite: jsonObject[jsonKey]
            });
            newContext.oldValue = newOldValue;
            const newValue = itemPropSchema.deserializer(newContext);
            if (newValue.type === 'aspect') {
                newValue.name = jsonKey;
            }
            // jsonObject[jsonKey], objectContext, {
            //         ...attrContext,
            //         oldValue: newOldValue
            //       }
            if (!newMap.has(jsonKey) || newMap.get(jsonKey) !== newValue) {
                newMap.set(jsonKey, newValue);
            }
            // }
        }
        return newMap;
    }
}
export function map(propSchemaRaw) {
    let propSchema = propSchemaRaw;
    if (typeof propSchema !== 'function') {
        propSchema = propSchema || _defaultPrimitiveProp;
        invariant(isPropSchema(propSchema), 'expected prop schema as first argument');
        invariant(!isAliasedPropSchema(propSchema), 'provided prop is aliased, please put aliases first');
    }
    return new SerializrType_map(propSchema);
}
